import React, { useState } from "react";
import "../ContactForm.css";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactForm = () => {
  const [name, setName] = useState("");
  const [firstname, setFirstname] = useState("");
  const [Email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceId = "service_mbt2p1u";
    const templateId = "template_0r2imh6";
    const publicKey = "slbpreLJOMp0gyS41";

    const templateParams = {
      from_name: name,
      from_firstname: firstname,
      from_email: Email,
      from_phone: phone,
      message: message,
    };

    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        console.log("Email sent successfully ", response);
        toast.success("Votre message a été envoyé avec succès !");
        setName("");
        setFirstname("");
        setEmail("");
        setPhone("");
        setMessage("");
      })
      .catch((error) => {
        console.log("Error sending email: ", error);
        toast.error(
          "Échec de l'envoi du message. Veuillez réessayer plus tard."
        );
      });
  };

  return (
    <>
      <div id="Contact" className="container mt-5">
        <form className="form" onSubmit={handleSubmit}>
          <p className="title">Formulaire de Contact</p>
          <label htmlFor="nom" className="label text-start">
            Nom
          </label>
          <input
            id="nom"
            placeholder="Nom"
            className="input "
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <label htmlFor="Prénom" className="label mt-3">
            Prénom
          </label>
          <input
            id="prenom"
            placeholder="Prénom"
            className="input"
            type="text"
            required
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
          />
          <label htmlFor="Email" className="label mt-3">
            Email
          </label>
          <input
            id="email"
            placeholder="Email"
            className="input"
            type="email"
            required
            value={Email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <label htmlFor="phone" className="label mt-3">
            N° téléphone
          </label>
          <input
            id="phone"
            placeholder="N° téléphone"
            className="input"
            type="tel"
            required
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <label htmlFor="message" className="label mt-3">
            Message
          </label>
          <textarea
            id="message"
            placeholder="Votre message"
            className="input message"
            rows="10"
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
          <button id="btn" type="submit">
            Envoyer
          </button>
        </form>
      </div>
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-12 col-md-10 col-lg-8">
            <ToastContainer />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
